<template>
<DropDownSelect @open="fetchFiatCurrencyList">
  <template #value>
    {{ props.value.code }}
  </template>
  <template #default="{hide}">
    <ExchangeLoading v-if="fiatCurrencies.loading" />
    <template v-else>
      <div v-for="currency in fiatCurrencies.items"
        :key="currency.code"
        class="drop-down-item"
        :class="{ 'is-selected': currency.code === props.value.code}"
        @click="selectCurrency(currency); hide()"
      >
        {{ currency.code }}
      </div>
    </template>
  </template>
</DropDownSelect>
</template>

<script setup lang="ts">
import DropDownSelect from "@kano/components/CryptoPriceChart/Chart/DropDownSelect.vue";
import PricesClient from "@kano/services/clients/seo-client";
import { useMemoize } from "@vueuse/core";
import { useSimpleList } from "@kano/composables";
import { PriceChartCurrency } from "@kano/types/crypto-price-chart";
import ExchangeLoading from "@kano/components/ExchangeFormV2/ExchangeLoading.vue";

const props = defineProps<{
  value: PriceChartCurrency,
}>();

const emit = defineEmits<{
  (event: 'input', value: PriceChartCurrency): void,
}>();

const getFiatCurrencyList = useMemoize(() => PricesClient.getAvailableFiatCurrencies());
const { state: fiatCurrencies, fetch: fetchFiatCurrencyList } = useSimpleList({
  list: () => getFiatCurrencyList(),
});

const selectCurrency = (currency: PriceChartCurrency) => {
  emit("input", currency);
}
</script>

<style scoped lang="scss">
.drop-down-item {
  font-family: Inter Tight, Inter Tight fallback, sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  margin-bottom: 8px;

  &:hover {
    cursor: pointer;
    color: var(--color-base-48);
  }
}

.is-selected {
  color: var(--color-primary);
}
</style>